import { RULE_REC_TYPE } from '../../../../constants';
import FileRulesStore from '../FileRulesStore';

export const SUPPORTED_FILE_TYPES = [
    'ace', 'add', 'arj', 'bas', 'bat', 'class', 'cmd', 'com', 'contact', 'cpl', 'csv', 'der', 'diagcab',
    'dll', 'dmg', 'doc', 'docm', 'docx', 'dot', 'dotm', 'dotx', 'exe', 'fon', 'grp', 'hta', 'img', 'inf',
    'ins', 'isp', 'iqy', 'iso', 'jar', 'jnlp', 'jse', 'mam', 'mcf', 'mht', 'msc', 'msh', 'msh1', 'msh1xml',
    'msh2', 'msh2xml', 'mshxml', 'msi', 'msp', 'mst', 'msu', 'ocx', 'odp', 'ods', 'odt', 'pdf', 'pif',
    'pl', 'pot', 'potm', 'potx', 'ppa', 'ppam', 'pps', 'ppsm', 'ppsx', 'ppt', 'pptm', 'ps1', 'ps1xml',
    'ps2', 'ps2xml', 'psc1', 'psc2', 'psdm1', 'psdm1', 'pptx', 'pub', 'py', 'pyc', 'pyo', 'pyw', 'pyz',
    'pyzw', 'reg', 'scf', 'scr', 'sct', 'sh', 'shb', 'shs', 'slk', 'swf', 'vb', 'vbe', 'vbp', 'vbs',
    'vcard', 'vcf', 'vcs', 'vhdx', 'vhd', 'vxd', 'wmv', 'ws', 'wsc', 'wsf', 'wsh', 'xbap', 'xht', 'xla',
    'xlam', 'xlm', 'xls', 'xlsb', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx', 'xnk', 'xps', 'xxe', 'zip'
];

export default class FileThreatRulesStore extends FileRulesStore {
    static PATH = '/console/filethreat-rules';
    static PUBLIC_PATH = '/api/v3/filethreat-rules';

    constructor(data = {}) {
        super({
            path: FileThreatRulesStore.PATH,
            supportedFileTypes: SUPPORTED_FILE_TYPES,
            type: RULE_REC_TYPE.FILE_THREAT_RULES,
            ...data,
        });
    }
}
